import { matchPath } from 'react-router-dom'
import { Site } from '@envato/foundation-types'
import { IFlatQuery } from './location/types'

import { getConfigBySite } from '../../config/sites'

interface INoIndexParam {
  name: string
  value?: string
}

const urlPathIsIndexable = (path: string, site: Site) => {
  const config = getConfigBySite(site, 'noIndex.routes') || []

  const pathMatchesNoIndexPath = config.some(
    (notIndexablePath: string) =>
      matchPath(path, { path: notIndexablePath, exact: true, strict: true }) !==
      null
  )

  return !pathMatchesNoIndexPath
}

const siteParamsConfig = (site: Site) =>
  (getConfigBySite(site, 'noIndex.params') || []) as Array<INoIndexParam>

const searchTermContainsFree = (locationParams: IFlatQuery) => {
  const term = locationParams.term
  const regex = /(^|\s)free(\s|$)/i

  return regex.test(term)
}

const urlContainsProhibitedParams = (
  locationParams: IFlatQuery,
  siteParamsConfig: Array<INoIndexParam>
) => {
  return siteParamsConfig.some(({ name, value }) => {
    const locationParam = locationParams[name]

    return (
      name !== 'tags' &&
      !!locationParam &&
      (value ? locationParam === value : true)
    )
  })
}

const urlHasNoTagsOrContainsAllowedTags = (
  locationParams: IFlatQuery,
  siteParamsConfig: Array<INoIndexParam>
) => {
  if (locationParams.tags) {
    return siteParamsConfig.some(({ name, value }) => {
      const locationParam = locationParams[name]
      return name === 'tags' && locationParam === value
    })
  }

  return true
}

const urlIsIndexible = (
  locationParams: IFlatQuery,
  path: string,
  site: Site
) => {
  const paramsConfig = siteParamsConfig(site)

  return (
    urlPathIsIndexable(path, site) &&
    urlContainsProhibitedParams(locationParams, paramsConfig) === false &&
    searchTermContainsFree(locationParams) === false &&
    urlHasNoTagsOrContainsAllowedTags(locationParams, paramsConfig)
  )
}

export const shouldPageHaveNoIndexTag = (
  locationParams: IFlatQuery,
  path: string,
  site: Site
) => {
  return !urlIsIndexible(locationParams, path, site)
}

export const getRelAttributeValue = (
  itemsCount: number,
  locationParams: IFlatQuery,
  site: Site
) => {
  const pageHasTooFewItems = itemsCount < 2
  const pageHasTooManySelectedTags =
    (locationParams.tags || '').split(',').length > 1
  const isNoFollowUrl =
    pageHasTooFewItems ||
    pageHasTooManySelectedTags ||
    urlContainsProhibitedParams(locationParams, siteParamsConfig(site)) ||
    urlHasNoTagsOrContainsAllowedTags(
      locationParams,
      siteParamsConfig(site)
    ) === false

  return isNoFollowUrl ? 'nofollow' : undefined
}
